import script from "./SupportResistanceTable.vue?vue&type=script&lang=js"
export * from "./SupportResistanceTable.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__